import React, {
  RefObject,
} from 'react';
import clsx from 'clsx';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import Filters from 'core/Filters';
import {
  useFilterQueryWithDateRange,
  useTableReset,
} from 'core/hooks';
import SearchIcon from 'core/icons/search';
import {
  FormWorkflowFilterDTO,
} from 'dtos';
import DateRangePicker from 'core/components/DateTimePicker/DateRangePicker';
import SearchInput from 'pages/Dashboard/components/SearchInput';
import {
  useSyncSearchQuery,
} from 'pages/Dashboard/hooks/url';
import QueryTable from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/Overview/QueryTable';
import {
  FilterInstance,
} from 'core/Filters/types';

export default function FormWorkflowsPage() {
  const { reset, tableInstanceRef } = useTableReset();
  const {
    searchQuery,
    setSearchQuery,
  } = useSyncSearchQuery();
  const {
    filterQuery,
    setFilterQuery,
    filterInstanceRef,
    dateRange,
    setDateRange,
  } = useFilterQueryWithDateRange<FormWorkflowFilterDTO>(
    'formWorkflows',
    {
      uniqueKey: 'formWorkflowsRange',
      unit: 'day',
      amount: 30,
    },
    true,
  );

  const onFilterUpdate = () => {
    setFilterQuery(filterInstanceRef?.current?.getFilterQuery?.() ?? {});
    reset();
  };

  return (
    <>
      <h3 className="font-semibold text-xl pt-4 px-4 mb-4 pb-1">Form Workflow</h3>
      <div className={clsx('flex justify-between items-center mb-4 px-4')}>
        <div className="flex gap-4 flex-row">
          <SearchInput
            placeholder="Enter patient name, phone or date of birth"
            className="w-96"
            value={searchQuery}
            onChange={(val) => {
              setSearchQuery(val);
              reset();
            }}
            inputProps={{
              autoComplete: 'off',
            }}
            icon={<SearchIcon className="!w-4 !h-4 text-gray-400" />}
            id="form-workflow-patient-search"
          />
          <DateRangePicker
            value={dateRange}
            onChange={(nextDateRange) => {
              if (nextDateRange) {
                setDateRange(nextDateRange);
                reset();
              }
            }}
          />
          <Filters
            pageObject="formWorkflows"
            onFilterUpdate={onFilterUpdate}
            instanceRef={filterInstanceRef as RefObject<FilterInstance>}
            useStorage
          />
        </div>
      </div>
      <div className="relative flex flex-col flex-1 overflow-y-hidden">
        <div className="w-full h-full">
          <QueryTable
            dateRange={dateRange}
            filterQuery={filterQuery}
            searchQuery={searchQuery}
            tableInstanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
          />
        </div>
      </div>
    </>
  );
}
